'use client';

const MIXPANEL_BAD_ID_VALUES = new Set([
  '',
  '-1',
  '0',
  '00000000-0000-0000-0000-000000000000',
  '<nil>',
  '[]',
  'anon',
  'anonymous',
  'false',
  'lmy47d',
  'n/a',
  'na',
  'nil',
  'none',
  'null',
  'true',
  'undefined',
  'unknown',
  '{}',
]);

export function normalizeAnalyticsIdentifier(value: string | null | undefined): string | null {
  if (value == null) {
    return null;
  }

  let normalized = value.trim();
  if (!normalized) {
    return null;
  }

  try {
    normalized = decodeURIComponent(normalized).trim();
  } catch {
    // Keep the raw value when a malformed cookie cannot be decoded.
  }

  return MIXPANEL_BAD_ID_VALUES.has(normalized.toLowerCase()) ? null : normalized;
}

export function readActorIdCookie(): string | null {
  if (typeof document === 'undefined') {
    return null;
  }

  const match = document.cookie.match(/(?:^|;\s*)ss_actor_id=([^;]*)/);
  return normalizeAnalyticsIdentifier(match?.[1]);
}
